import { useState } from 'react';
import { Link } from 'react-router-dom';
import SignupHero from './components/SignupHero';
import SignupBenefits from './components/SignupBenefits';
import SignupFormBlock from './components/SignupForm';
import SignupTrust from './components/SignupTrust';

const SignupPage = () => {
  const [activeTab, setActiveTab] = useState<'signup' | 'login'>('signup');

  return (
    <>
      <title>Create Account | Everything Automation Member Signup</title>
      <meta name="robots" content="noindex, nofollow" />
      <main className="bg-ea-black">
        <SignupHero activeTab={activeTab} onTabChange={setActiveTab} />
        <SignupFormBlock activeTab={activeTab} onTabChange={setActiveTab} />
        <SignupBenefits />
        <SignupTrust />

        {/* Footer CTA */}
        <section className="bg-ea-navy py-24 relative overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-r from-ea-blue/5 via-transparent to-ea-blue/5"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-ea-blue/5 blur-3xl pointer-events-none"></div>
          </div>
          <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-12 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ea-blue/10 border border-ea-blue/30 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-ea-blue animate-pulse"></span>
              <span className="text-ea-blue text-xs font-medium uppercase tracking-wider">Join Free Today</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Join Everything Automation<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-ea-blue to-ea-blue-electric">
                Stay Ahead of the Curve
              </span>
            </h2>
            <p className="text-ea-gray text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
              Create your free account and be the first to access the newest AI automations for your business. Don&apos;t let competitors get there first.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#auth-section"
                className="px-8 py-4 bg-ea-blue hover:bg-ea-blue-light text-white font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-base flex items-center gap-2"
                style={{ boxShadow: '0 0 25px rgba(14, 165, 233, 0.3)' }}
                rel="nofollow"
              >
                <i className="ri-user-add-line"></i>
                Create Free Account
              </a>
              <Link
                to="/contact"
                className="px-8 py-4 bg-transparent hover:bg-ea-dark-card text-white border border-ea-dark-border hover:border-ea-blue font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-base flex items-center gap-2"
              >
                <i className="ri-calendar-line"></i>
                Book a Demo Instead
              </Link>
            </div>
            <p className="text-ea-gray/50 text-xs mt-6">
              Free forever &bull; No credit card required &bull; Unsubscribe anytime
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default SignupPage;
